import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataStateChangeEventArgs } from "@syncfusion/ej2-angular-grids";
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { ErrorService } from "src/app/error.service";
import { GeneralService } from "src/app/service/general.service";
import { PurchaseVListBO } from "./verifications.model";

@Injectable({
  providedIn: "root",
})
export class CombinedVerificationsService extends Subject<DataStateChangeEventArgs> {
  timesheetListId: any = [];
  timesheetVList:any=[]
  errorlist: any = [];
  purchaseRequestId: any;
  timesheetId: any;
  transactionId: any;
  VerificationId: any;
  ErrorNotes:any
  constructor(
    private http: HttpClient,
    public errorService: ErrorService,
    public general: GeneralService,
    public datePipe: DatePipe
  ) {
    super();
  }
  public execute(state: PurchaseVListBO): void {
    this.getTimesheetList(state).subscribe((x) => super.next(x));
  }
  getTimesheetList(
    state?: PurchaseVListBO
  ): Observable<DataStateChangeEventArgs> {
    return this.http
      .post<any>(
        "api/CombinedVerification/getCSGVerifications",
        state
      )
      .pipe(
        map(
          (response: any) =>
            <any>{
              result: response["result"],
              count: response["count"],
            }
        )
      )
      .pipe(
        map((datas: any) => {
          this.timesheetVList=[]
          this.timesheetVList=datas.result
          return datas
        })
      )

      .pipe(
        map((data: any) => {
          data.result = this.setTimesheetVdata(data);
         
          return data;

        })
      );
  }

  gettimesheetVerifyList(){
    console.log(this.timesheetVList,"this.timesheetVList")
    return this.timesheetVList
  }
  setTimesheetVdata(data) {
    this.errorlist=[]
    this.timesheetListId=[]
    this.ErrorNotes=null
    this.timesheetListId = data.result;
    let parentArray = [];
    let clientId: string;
    let companyId: string;
    let grouppayorId: string;
    let grouppayorServiceId: string;
    let clietauthId: string;
    let employeeId: string;
    let payrname: string;
    let objArray: any = [];
    if (data.result.length != 0) {
      data.result.forEach((element) => {
        this.purchaseRequestId = element.purchaseRequestId;
        this.timesheetId = element.timesheetId;
        this.transactionId = element.transactionId;
        this.VerificationId = element.id;
        //ErrorTimeshetVerificationList//
        let btncount = 0;
        let buttoncolor: any;
        clientId = element.clientId;
        companyId = element.company_Id;
        grouppayorId = element.payer_PayorId; 
        grouppayorServiceId = element.payerCompanyMap_Id; 
        clietauthId = element.clientAuthorizationId;
        employeeId = element.employee_Id;
        payrname = element.payer_PayorName;

        element.error.forEach((element) => {
          if (element.isValid == true) {
            element.color = "green";
            element.colr = "green";
            element.status = "Valid";
          }
          if (element.isValid == false) {
            element.color = "red";
            element.colr = "red";
            element.status = "Not valid";
          }
          element.purchaseRequestId = this.purchaseRequestId;
          element.transactionId = this.transactionId;
          element.timesheetId = this.timesheetId;
          element.id = this.VerificationId;
          // element.clientId = clientId;
          // element.companyId = companyId;
          // element.groupPayorId = grouppayorId;
          // element.grouppayorServiceId = grouppayorServiceId;
          element.clientauthId = clietauthId;
          // element.employeeId = employeeId;
          // element.payorName = payrname;
                  
          this.errorlist.push(element);
        });
   
    
        if (element.claimStatus == "Validate") {
          element.bit = 1;
          (element.color = "red"), 
          (buttoncolor = "red");
        } 
        else if (element.claimStatus == "OverUnits") {
          element.bit = 0;
          element.color = "yellow";
          buttoncolor = "yellow";
        } 
        else {
          element.bit = 0;
          element.color = "green";
          buttoncolor = "green";
        }
        let createdDate = this.datePipe.transform(element.createdDate, "MM/dd/yyyy");

        let obj = {
          client_Name: element.client_Name,
          payer_PayorName: element.payer_PayorName,         
          employeeID: element.employee_Id,          
          quantity: element.quantity,
          employee_Name: element.employee_Name,
          employee_UMPI: element.employee_UMPI,
          billingAmount: element.totalAmount,
          claimStatus: element.claimStatus,
          claimType: element.claimType,
          errorNotes: element.errorNotes,
          purchaseRequestId: element.purchaseRequestId,
          transactionId: element.transactionId,
          timesheetId: element.timesheetId,
          id: element.id,
          buttoncolor: buttoncolor,
          color: element.color,
          bit: element.bit,
          validate: "",
          isVisitApproved: element.isVisitApproved,
          serviceName:element.serviceName,
          rate:element.payrate,
          createdDate:createdDate ,
          timesheetNotes:element.timesheetNotes,          
          serviceCodeToDisplay:element.serviceCodeToDisplay,
          auth_ServiceAgreementNumber: element.auth_ServiceAgreementNumber,
          auth_InsuranceNumber: element.auth_InsuranceNumber,
          auth_ICD10Code:element.elementauth_ICD10Code,
          hours: element.hours,
          totalAmount: element.totalAmount,
          payrate: element.payrate
        };

        objArray.push(obj);
        this.ErrorNotes=objArray.errorNotes
        parentArray = objArray;
      });
    } else {
      parentArray = [];
     
    }
    return parentArray;
  }


  // Get All TimesheetVerification List..
  getAllTimeshettList() {
    return this.timesheetListId;
  }
  // Get  TimesheetVerification Errorlist
  getErrorlist() {
    return this.errorlist;
  }
  getErrorNotes(){
   return this.ErrorNotes
  }
}

